export default __webpack_public_path__ + "static/media/4_Knchelbruch.8d57d72e.png";